import React from 'react';

import { SiteConfigManager } from '@atlas/core';

import ChangeLanguageDropdown from 'components/LanguageSwitcher';

const FooterLanguageSwitcher = () => {
  const languages = SiteConfigManager.getConfig('languages', []);

  if (languages.length <= 1) {
    return null;
  }

  return <ChangeLanguageDropdown className="footer__lang bg dropdown-lang" />;
};

export default FooterLanguageSwitcher;
